<app-top-navigation [openLoginWindow]="isLoginOpen"></app-top-navigation>
<div class="motoText">
	<h3>{{ 'TRANS_REMOTE.TRANS_MOTO_PRICE' | translate }}</h3>
</div>
<div class="choice-container">
	<div class="btn-group btn-group-toggle" ngbRadioGroup name="radioBasic" [(ngModel)]="buyMode" (ngModelChange)="changeTab()">
		<label ngbButtonLabel class="btn-primary">
			<input ngbButton type="radio" value="single"> Single buy
		</label>
		<label ngbButtonLabel class="btn-primary">
			<input ngbButton type="radio" value="multiple"> Multiple buy with discount
		</label>
	</div>
</div>
<div class="containerCenter" *ngIf="buyMode === 'single'">
	<div class="d-flex">
		<ng-container *ngIf="$sites | async as sites else loader">
			<ul ngbNav #nav="ngbNav" class="nav-pills" orientation="vertical" style="background: #f9f9f9;">
				<li [ngbNavItem]="'site-'+site.id" *ngFor="let site of sites">
					<a ngbNavLink>
						<img [src]="site.slides[0]" />
						<div class="infoSite">
							{{globalDataService.getObjectTranslation(site.siteTranslations, "name")}}
							<div class="metaInfo">
								<div>{{globalDataService.getObjectTranslation(site.siteTranslations, 'address')}}</div>
							</div>
						</div>
					</a>
					<ng-template ngbNavContent>
						<app-site-packets [siteId]="site.id" [backDrop]="false" [inline]="true"></app-site-packets>
					</ng-template>
				</li>
			</ul>
			<div [ngbNavOutlet]="nav" class="ml-4"></div>
		</ng-container>
	</div>
</div>
<div class="containerCenter row" *ngIf="buyMode === 'multiple'">
	<div class="col-md-9">
		<div class="row">
			<ng-container *ngIf="$sites | async as sites else loader">
				<div class="siteContainer col-md-4" *ngFor="let site of sites">
					<input id="{{site.id + 'check'}}" type="checkbox" name="siteIds[]" [value]="site.id" (change)="checkBoxChange($event)" />
					<label for="{{site.id + 'check'}}">
						<a>
							<img [src]="site.slides[0]" />
							<div class="infoSite">
								{{globalDataService.getObjectTranslation(site.siteTranslations, "name")}}
								<div class="metaInfo">
									<div>{{globalDataService.getObjectTranslation(site.siteTranslations, 'address')}}</div>
								</div>
							</div>
						</a>
					</label>
				</div>
			</ng-container>
		</div>
	</div>
	<div class="col-md-3">
		<ng-container *ngIf="multipleSitesSelected.length < 2">
			<p style="height: 100%; padding: 50% 0; text-align: center;">
				{{"TRANS_REMOTE_PRICE_LIST.TRANS_MULTI_ERROR" | translate}}
			</p>
		</ng-container>
		<ng-container *ngIf="multipleSitesSelected.length >1">
			<div>{{"TRANS_REMOTE_PRICE_LIST.TRANS_SELECT" | translate}}:</div>
			<ng-select [(ngModel)]="selectedDay">
				<ng-option *ngFor="let day of groupedDays" [value]="day">{{day}} days</ng-option>
			</ng-select>
			<span class="danger" *ngIf="!selectedDay">{{"TRANS_REMOTE_PRICE_LIST.TRANS_TIME_ERROR" | translate}}</span>
			<div class="selectionsContainer" *ngIf="selectedDay">
				<span class="infoPrice">
					{{"TRANS_REMOTE_PRICE_LIST.TRANS_YOU_SELECTED" | translate}} {{multipleSitesSelected.length}}
					{{"TRANS_REMOTE.TRANS_ARCHAIOLOGICALS" | translate}} -{{getDiscount()}}%
				</span>
				<ul class="siteList" *ngIf="selectedDay">
					<li *ngFor="let siteId of multipleSitesSelected">
						<div *ngIf="getSite(siteId) | async as siteDto">
							{{this.globalDataService.getObjectTranslation(siteDto.siteTranslations, "name")}}
							<span class="priceTime">
								{{getPacketPrice(siteId) ? getPacketPrice(siteId).price : 0}}&euro;
							</span>
						</div>
					</li>
				</ul>
				<div class="finalPrice">
					<div><b>{{"TRANS_REMOTE_PRICE_LIST.TRANS_SUB_TOTAL" | translate}}:</b> {{getTotalPrice()}}&euro;</div>
					<div><b>{{"TRANS_REMOTE_PRICE_LIST.TRANS_DISCOUNT" | translate}}:</b> -{{getDiscount()}}%</div>
					<div><b>{{"TRANS_REMOTE_PRICE_LIST.TRANS_TOTAL" | translate}}:</b> {{getTotalPrice(true)}}&euro;</div>
				</div>
				<div style="text-align: center;margin-top: 2rem;"[style.opacity]="checkComboOwned() ? 0.8 : 1">
					<a class="buyNow" href="javascript:void(0)" (click)="toBuyPage()"> {{"TRANS_REMOTE.TRANS_BUYNOW" | translate}}
						{{"TRANS_REMOTE_BUY.TRANS_FOR" |
						translate}} {{getTotalPrice(true)}}&euro;</a>
				</div>
				<div class="" style="color: red; margin-top: 7px; text-align: center;" *ngIf="checkComboOwned()">
					{{"TRANS_REMOTE_PRICE_LIST.TRANS_ERROR_OWN" | translate}}
				</div>
			</div>
		</ng-container>
	</div>
</div>
<ng-template #loader>
	<div class="step text-center" style="margin-top: 100px;position: absolute;left:45%">
		<div class="loader-block">
			<svg id="loader2" viewBox="0 0 100 100">
				<circle id="circle-loader2" cx="50" cy="50" r="45"></circle>
			</svg>
		</div>
		<div>LOADING....</div>
	</div>
</ng-template>